export const isSessionExpired = () => {
    const token = localStorage.getItem('jwt');
    if (!token) return true;
  
    const tokenPayload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;
    return tokenPayload.exp < currentTime;
  };